import { QueueSummaryResponse } from 'app/modules/queues/responses';
import { ShortAgentResponse } from 'app/modules/agents/responses';

export interface Narrative {
  id: number;
  narrative: string;
  article_id: number;
  queue?: QueueSummaryResponse;
  created_at: string;
  created_by: ShortAgentResponse;
  edited_by: ShortAgentResponse;
  updated_at: string;
  archived: boolean;
  added_to_record_by: ShortAgentResponse;
  is_automated: boolean;
}

export enum NarrativesType {
  ALERTS = 'alerts',
  CASES = 'cases',
}
